import { useState } from 'react'
import { Link } from 'react-router-dom'
import { t } from '../../adapters/translate/translate'
import Logo from '../../components/logo'
import HelpModal from '../../components/modais/help_modal'
import { AlertBox } from '../../components/ui/layout'
import { useAlertBox, useGame, useTabBarContext, useTerms } from '../../contexts'
import { getAssetUrl } from '../../utils/assets_helpers'
import { logOut } from '../../utils/auth_helpers'
import WidgetIcons from '../../utils/icons'
import { getUser } from '../../utils/storage/user'
import {
  ContainerMoreDesktop,
  BackDrop,
  ItemMoreDesktop,
  LogoContainer,
  Name,
  Button,
  ContainerDesktop,
  BottomDesktopContainer,
  TopContainerDesktop,
  WelcomeName
} from './styles'

const MoreDesktop = ({ isVisible = false, close = () => {} }) => {
  const { game } = useGame()
  const { handleChangeTab } = useTabBarContext()
  const { alertBox, closeBox } = useAlertBox()
  const user = getUser()
  const [openHelpModal, setOpenHelpModal] = useState<any>(false)
  const { handleToggleTermsModal, handleTogglePrivacyPolicyModal } = useTerms()

  const openDocument = () => {
    window.open(getAssetUrl('documentAttachment', game?.documentAttachment))
  }

  const LIST_ITEMS = [
    {
      title: t('Close'),
      icon: 'FaRegWindowClose',
      page: '',
      action: async () => {
        close()
      }
    },
    {
      title: t('Change Password'),
      icon: 'RiLockPasswordLine',
      action: () => handleChangeTab('changePassword')
    },
    {
      content: null,
      name: 'PrivacyPolicy',
      title: t('PrivacyPolicy'),
      activeIcon: 'RiSpyLine',
      icon: 'RiSpyLine',
      action: handleTogglePrivacyPolicyModal
    },
    {
      content: null,
      name: 'TermsofUse',
      title: t('Terms of Use'),
      activeIcon: 'RiNewspaperLine',
      icon: 'RiNewspaperLine',
      action: handleToggleTermsModal
    },
    {
      title: t('Sign Out'),
      icon: 'RiLoginBoxLine',
      page: '',
      action: async () => {
        alertBox(t('Do you really want to sign out?'), [
          {
            title: t('No'),
            action: () => {
              closeBox()
              close()
            }
          },
          {
            title: t('Yes'),
            action: () => {
              closeBox()
              close()
              logOut()
            }
          }
        ])
      }
    }

  ]

  if (game?.documentAttachment) {
    LIST_ITEMS.splice(3, 0,
      {
        title: t('Document'),
        icon: 'RiFile2Fill',
        action: () => openDocument()
      })
  }
  return (
    <>
      <ContainerDesktop className={isVisible ? 'motionL' : 'motionR'}>
        <BackDrop onClick={close} />
        <ContainerMoreDesktop className='more'>
          <TopContainerDesktop>
            <LogoContainer>
              <Logo centerImage />
            </LogoContainer>

            <WelcomeName>{t('Welcome')}</WelcomeName>
            <Name>{user?.nickname || ''}</Name>
          </TopContainerDesktop>

          <BottomDesktopContainer>
            {
              LIST_ITEMS.map((item, index) => (

                item.action && (
                      <Button key={index} onClick={() => {
                        item.action?.()
                        close()
                      }}
                      >
                      <ItemMoreDesktop key={index}>
                        <WidgetIcons name={item.icon} size={22} color='#000' />

                        {
                          item.page && (<Link to={item.page}>{item.title}</Link>)
                        }

                        {item.title}
                        </ItemMoreDesktop>
                      </Button>
                )

              ))
            }
          </BottomDesktopContainer>

        </ContainerMoreDesktop>
      </ContainerDesktop>
      <AlertBox />
      {openHelpModal && <HelpModal isAnonymous={false} handleClose={() => setOpenHelpModal(false)} />}
    </>
  )
}

export default MoreDesktop
